import React from "react";
import { Row, Col, Container } from "react-bootstrap";

// Reusable shimmer / skeleton blocks for the Fee Structure module.
// Uses the `.fee-shimmer` class defined in _feeStructure.scss (loaded module-wide
// via FeeStructureHome), matching the dashboard's existing shimmer aesthetic.

export const Shimmer = ({ width = "100%", height = 14, radius = 6, style = {} }) => (
    <div className="fee-shimmer" style={{ width, height, borderRadius: radius, ...style }} />
);

// Generic table skeleton (header row + body rows).
export const FeeTableShimmer = ({ rows = 7, cols = 8 }) => {
    const widths = [60, 120, 90, 80, 60, 70, 80, 70, 80, 90, 70, 70];
    const cells = widths.slice(0, cols);
    return (
        <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 16, padding: "16px 20px" }}>
            <div style={{ display: "flex", gap: 12, padding: "10px 0", borderBottom: "2px solid #f3f4f6", marginBottom: 4 }}>
                {cells.map((w, i) => <Shimmer key={i} width={w} height={13} style={{ flexShrink: 0 }} />)}
            </div>
            {Array.from({ length: rows }).map((_, r) => (
                <div key={r} style={{ display: "flex", gap: 12, padding: "13px 0", borderBottom: "1px solid #f3f4f6", alignItems: "center" }}>
                    {cells.map((w, i) => <Shimmer key={i} width={w} height={12} style={{ flexShrink: 0 }} />)}
                </div>
            ))}
        </div>
    );
};

// Report skeleton: three summary chips + a table (Fee Report modal).
export const FeeReportShimmer = () => (
    <div style={{ padding: "20px 22px" }}>
        <div style={{ display: "flex", gap: 12, marginBottom: 18, flexWrap: "wrap" }}>
            {[0, 1, 2].map((i) => <Shimmer key={i} width={160} height={62} radius={12} style={{ flex: 1, minWidth: 140 }} />)}
        </div>
        <FeeTableShimmer rows={6} cols={6} />
    </div>
);

// Full-page skeleton for the initial fee data load (tab header + stat cards + charts).
export const FeePageShimmer = () => (
    <div style={{ background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)", minHeight: "100vh", padding: "24px 28px" }}>
        <Container fluid className="px-0">
            <div style={{ background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "hidden", border: "1px solid #e2e8f0" }}>
                {/* Tab header */}
                <div style={{ background: "#f8fafc", borderBottom: "1.5px solid #e2e8f0", padding: "16px 24px", display: "flex", gap: 10 }}>
                    {[0, 1, 2, 3].map((i) => <Shimmer key={i} width={120} height={30} radius={8} />)}
                </div>
                {/* Body: stat cards + chart blocks */}
                <div style={{ padding: 28 }}>
                    <Row className="g-3 mb-3">
                        {[0, 1, 2, 3].map((i) => (
                            <Col xl={3} md={6} sm={6} key={i} className="mb-3">
                                <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 16, padding: "18px 20px", display: "flex", alignItems: "center", gap: 16 }}>
                                    <Shimmer width={50} height={50} radius={12} style={{ flexShrink: 0 }} />
                                    <div style={{ flex: 1 }}>
                                        <Shimmer width="55%" height={11} style={{ marginBottom: 8 }} />
                                        <Shimmer width="75%" height={20} style={{ marginBottom: 6 }} />
                                        <Shimmer width="45%" height={9} />
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                    <Row className="g-3 mb-3">
                        {[7, 5].map((span, i) => (
                            <Col xl={span} lg={span} key={i} className="mb-3">
                                <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 16, padding: "20px 24px" }}>
                                    <Shimmer width={180} height={14} style={{ marginBottom: 20 }} />
                                    <Shimmer width="100%" height={240} radius={10} />
                                </div>
                            </Col>
                        ))}
                    </Row>
                </div>
            </div>
        </Container>
    </div>
);
